<template>
  <div class="list-area main-notice-list">
    <div class="list-header align-center">
      <div class="list-tab-box">
        <ul class="tab-name">
          <!-- active 된곳에 is-active 추가 -->
          <li
            v-for="item in boardList"
            :key="item.oid"
            :class="item.active"
            v-text="item.name"
            @click="getPostingList(item)"
          />
        </ul>
        <el-button @click="goBoardList">
          <span class="material-icons md">add</span>
        </el-button>
      </div>
    </div>
    <div class="list-body">
      <div class="list-wrapper">
        <!-- no-data -->
        <the-no-data :fetch-state="false" :list-count="listCount"/>
        <div class="data-list">
          <!--------- for --------->
          <div class="list-item" v-for="item in postingList" :key="item.oid" @click="goView(item)">
            <!-- 첫째줄외엔 숨김처리됨 -->
            <div class="label-area">
              <span class="year" v-text="$util.dateUtils.getYear( item.inputDate )"/>
              <span class="date" v-text="$util.dateUtils.getMonth( item.inputDate ) + '.' + $util.dateUtils.getDate( item.inputDate )"/>
            </div>
            <div class="txt-area">
              <!-- inner-top -->
              <div class="inner-top">
                <!--첫째줄은 inner-label 비활성화 그 외는 활성화-->
                <span class="inner-label" v-text="$util.dateUtils.delimFormatDate( item.inputDate, '-' )"/>
                <div class="title-container">
                  <div v-if="1 === item.noticeLevel" class="label"><span>공지</span></div>
                  <span class="inner-tit" v-text="item.title"></span>
                </div>
              </div>
              <!--- 첫번째 빼고는 숨김처리됨 -->
              <div class="inner-bottom">
                <span class="inner-txt" v-html="item.contents ? froalaEditorUtil.removeAllInlineEventHandler( item.contents ) : '-'">
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 게시글 비밀번호 확인 모달 -->
    <the-check-posting-password-modal
      :visible="passwordInputDialogVisible"
      :posting-info="clickedPostingInfo"
      @success="successCheckPassword"
      @close="closeCheckPassword"
    />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import TheNoData from "~/components/common/nodata/TheNoData";
import froalaEditorUtil from "~/utils/site/portal/froala_editor_util";
import portalApiUrl from '~/constant/site/portal/portalApiUrl';
import TheCheckPostingPasswordModal from "~/components/portal/user/modal/board/TheCheckPostingPasswordModal.vue";

export default {
  name       : "TheMainNoticeList",
  components : {  TheCheckPostingPasswordModal, TheNoData },
  data() {
    return {

      // 비밀번호 입력 모달
      passwordInputDialogVisible : false,
      // 비밀번호 모달을 띄울 때 해당 게시글 정보
      clickedPostingInfo : {
        postingOid : "",
        boardOid : "",
      },

      menuOid : "",
      listCount : 0,
      postingList : [],

      boardList : [
        {
          boardOid : "1SqydbhO000",
          name : "공지사항",
          active : "is-active",
        },
        {
          boardOid : "1Sr9XUT8001",
          name : "과학교육",
          active : "",
        },
        {
          boardOid : "1Sr9XUT800A",
          name : "정보교육",
          active : "",
        },
        {
          boardOid : "1Sr9XUT800J",
          name : "정보영재교육",
          active : "",
        },
      ],

      froalaEditorUtil, //인라인 이벤트 핸들러를 이용한 XSS를 막기 위해 인라인 이벤트를 제거하기 위해 탬플릿에서 사용
    }
  },

  computed : {
    ...mapGetters( {
      loginUserInfo : "common/login/loginUserInfo",
    } ),
  },

  async fetch() {
    await this.getPostingList( this.boardList[0] );
  },

  methods : {
    /* 각 boardOid의 리스트를 가져옵니다. */
    async getPostingList( item ) {

      this.boardList.forEach( board => {
        if ( item === board ) {
          board.active = "is-active";
        }
        else {
          board.active = "";
        }
      } )

      let param = {
        startIndex   : 1,
        pageSize     : 7,
        boardOid        : item.boardOid,
        fillBoardInfo   : true,
        fillContents : true,
      };

      await this.$axios.post( portalApiUrl.USER.POSTING.LIST, param ).then( res => {

        if ( this.$validate.isEmpty( res.data.list ) ) {
          this.postingList = [];
          this.listCount = 0;
          return;
        }

        this.activeBoard = item;
        this.postingList = res.data.list;
        this.listCount = res.data.listCount;
        this.menuOid = this.postingList[ 0 ].boardInfo.targetOid;
      } );
    },

    goView( item ) {

      // 로그인 후 조회할 수 있는 게시글일 경우
      if ( this.$constant.FLAG_YN.YES === item.customField4 && this.$validate.isEmpty( this.loginUserInfo.userOid ) ) {

        const res = this.$util.rsAlertUtils.swalWithOptions(
          "로그인 안내",
          `로그인한 사용자만 볼 수 있는 게시글입니다. \n 로그인 페이지로 이동하시겠습니까?`,
          "warning" );

        if ( res ) {

          const returnUrl = "/portal/user/common/commonBoard_list?menuOid=" + this.menuOid;

          if ( this.$constant.SSO_MODE ) {
            window.location.href =
              `${ process.env.SYSTEM.ACCOUNTS.URL }/v1/login/login?sys=portal&eox=${ window.location.origin }${returnUrl}`;
          }
          else {

            this.$router.push( {
              path : "/portal/user/login/user_login",
              query : { returnUrl : returnUrl },
            } );
          }
        }
      }

      // 비밀글이라면..
      if ( this.isAnonymous( item.anonymousYnVC ) ) {
        // 답글이라면...
        if ( this.$validate.isNotEmpty( item.objectMap ) || this.$validate.isNotEmpty( item.objectMap.parentInfo ) ) {
          // 부모글의 작성자가 로그인한 사람과 같으면 비밀번호 없이 볼 수 있어야 함!!
          this.$store.state.common.login.loginUser.userOid === item.objectMap.parentInfo.inputUser
            ? this.goViewPosting( item.postingOid, item.boardOid, this.menuOid )
            : this.openCheckPasswordModal( item );
        }
        else {

          // 자신이 쓴 글일 경우 비밀번호 없이 볼 수 있습니다.
          this.loginUserInfo.userOid === item.inputUser
            ? this.goViewPosting( item.postingOid, item.boardOid, this.menuOid )
            : this.openCheckPasswordModal( item );
        }
      }
      else {
        this.goViewPosting( item.postingOid, item.boardOid, this.menuOid );
      }
    },

    /* 비밀번호 모달 열기 */
    openCheckPasswordModal( item ) {

      this.clickedPostingInfo = item;
      this.passwordInputDialogVisible = true;
    },

    /* 비밀번호 확인 완료 후 */
    successCheckPassword( postingInfo ) {

      this.closeCheckPassword();
      this.goViewPosting( postingInfo.postingOid, postingInfo.boardOid, this.menuOid );
    },

    /* 비밀번호 모달 닫기 */
    closeCheckPassword() {
      this.clickedPostingInfo = {};
      this.passwordInputDialogVisible = false;
    },

    // 게시물로 이동
    goViewPosting( postingOid, boardOid, menuOid ) {

      this.$router.push( {
        path : "/portal/user/common/commonBoard_view",
        query : { postingOid, boardOid, menuOid }
      } );

    },

    // 더보기 시 해당 메뉴로 이동
    goBoardList() {
      this.$router.push( { path : "/portal/user/common/commonBoard_list", query : { menuOid : this.menuOid }, } );
    },

    /* 비밀글 여부 체크 */
    isAnonymous( anonymousYnVC ) {
      return this.$validate.isNotEmpty( anonymousYnVC ) && this.$constant.FLAG_YN.YES === anonymousYnVC;
    },
  }
}
</script>
<style scoped>
</style>
